module.exports = __webpack_public_path__ + "img/积分榜@2x.8e0c6af5.png";